interface SortableItem {
  createdDateTime?: string | Date;
  id?: string;
}

export const sortItem = (a: SortableItem, b: SortableItem) => {
  if (!a.id || !b.id) throw new Error('Missing item id');
  if (!a.createdDateTime || !b.createdDateTime) throw new Error('Missing item createdDateTime');
  const aDate = new Date(a.createdDateTime);
  const bDate = new Date(b.createdDateTime);
  const difference = bDate.getTime() - aDate.getTime();
  if (difference === 0) return a.id.localeCompare(b.id);
  return difference;
};

export const getRatio = (width?: number, height?: number) => {
  if (!width || !height) return;
  return width / height;
};
